export const COST_TYPE = {
  FUEL: 'FUEL_COST',
  BK_DRIVER: 'BK_DRIVER_COST',
  BK_MATE: 'BK_MATE_COST',
  AG_DRIVER: 'AG_DRIVER_COST',
  AG_MATE: 'AG_MATE_COST',
};

export const COST_LABEL = {
  FUEL: 'Fuel Cost',
  BK_DRIVER: 'Beko Driver Cost',
  BK_MATE: 'Beko Mate Cost',
  AG_DRIVER: 'Agency Driver Cost',
  AG_MATE: 'Agency Mate Cost',
  BK_DRIVER_CSV: 'Beko Driver Cost (£)',
  BK_MATE_CSV: 'Beko Mate Cost (£)',
  AG_DRIVER_CSV: 'Agency Driver Cost (£)',
  AG_MATE_CSV: 'Agency Mate Cost (£)',
  FUEL_CSV: 'Fuel Cost (£)',
};

export const ROLE = {
  PORTAL_ADMIN: 'Portal Admin',
  DEPOT_MANAGER: 'Depot Manager',
  DEPOT_AREA_MANAGER: 'Depot Area Manager',
  SUPERVISOR: 'Supervisor',
  BEKO_DRIVER: 'Beko Driver',
  BEKO_MATE: 'Beko Mate',
  AGENCY_DRIVER: 'Agency Driver',
  AGENCY_MATE: 'Agency Mate',
  CARRIER: 'Carrier',
  GUEST: 'Guest',
  QA: 'QA',
  WAREHOUSE_MAN: 'WarehouseMan',
  PLANNER_VIEW: 'Planner-View',
  DRIVER: 'Driver',
  MATE: 'Mate',
};

export const VEHICLE_TYPE = {
  BEKO_OWNED: 'Beko Owned',
  HIRED_VEHICLE: 'Hired Vehicle',
  CARRIER: 'Carrier',
  BULK: 'BULK',
};

export const JOB_STATUS = {
  ALL: 'all',
  APPROVAL_PENDING: 'ApprovalPending',
  APPROVED: 'Approved',
  NOT_COMPLETED: 'notCompleted',
  CANCELLED: 'Cancelled',
  PROCESSED: 'Processed',
};

export const COST_BUTTON_LABEL = {
  FUEL: 'Create Fuel Cost',
  BK_DRIVER: 'Create Beko Driver Cost',
  BK_MATE: 'Create Beko Mate Cost',
  AG_DRIVER: 'Create Agency Driver Cost',
  AG_MATE: 'Create Agency Mate Cost',
};

